export const environment = {
  production: false,
  pageTitle: {
    prefix: "",
    suffix: "Learning Link Staging",
    separator: " ⁃ "
  },
  baseUrl: "https://app.app.wdev0.com",
};
